import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Surveys.frontend.types'

@Injectable({ providedIn: 'root' })
export class Surveys_get_survey_context_details_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { surveyIds: number[] }): Promise<{ entities?: { type?: string, name?: string, surveyId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.surveyIds)) {
      missingRequiredInParams.push('\'surveyIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/functions/get_survey_context_details_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

